/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SecurityInputs */

const en_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security`)
};

const de_security = /** @type {(inputs: SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheit`)
};

/**
* | output |
* | --- |
* | "Security" |
*
* @param {SecurityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const security = /** @type {((inputs?: SecurityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SecurityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_security(inputs)
	return de_security(inputs)
});